import { Component, Input } from '@angular/core';
import { FeatureFlag } from '@app/enums';
import { TemplateType } from '@app/modules/performance/enums/template-type.enum';
import { AuthService } from '@app/services/auth.service';
import { FeatureService } from '@app/services/feature.service';
import { BaseForm } from '@forms/base.form';
import { Review } from '@models/performance/review.model';
import { Template } from '@models/performance/template.model';

@Component({
    selector: 'app-form-review-template',
    templateUrl: './review-template.template.html',
})
export class ReviewTemplateForm extends BaseForm {
    @Input() review: Review;

    templates: Template[];
    hasPerformanceModuleSplit = false;

    constructor(
        private auth: AuthService,
        private featureService: FeatureService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.hasPerformanceModuleSplit = await this.featureService.has(FeatureFlag.performanceModuleSplit);

        let query = Template.param('company', this.auth.company.id).where('hasQuestions', true).orderBy('name', 'ASC');

        query = this.hasPerformanceModuleSplit ? query.where('type', TemplateType.REVIEW) : query;

        const [templates] = await query.all();

        this.templates = templates;
    }
}
